const STATE = {
  active: 'is-active',
  current: 'is-current',
  hidden: 'ui-hide',
  inView: 'is-inview',
  noEvents: 'ui-no-events',
};

export default STATE;
